var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconApply3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/5.0-\\u6211\\u8981\\u7533\\u8ACB",
    transform: "translate(-911.000000, -265.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(365.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(504.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9032258,47.4193548 L1.93548387,47.4193548 C0.867096774,47.4193548 0,46.5522581 0,45.483871 L0,1.93548387 C0,0.867096774 0.867096774,0 1.93548387,0 L58.0645161,0 C59.1329032,0 60,0.867096774 60,1.93548387 L60,42.5806452",
    id: "Stroke-1",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,10.6451613 L60,10.6451613",
    id: "Stroke-3",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74193548,5.32258065 C7.74193548,6.12387097 7.09258065,6.77419355 6.29032258,6.77419355 C5.48806452,6.77419355 4.83870968,6.12387097 4.83870968,5.32258065 C4.83870968,4.52129032 5.48806452,3.87096774 6.29032258,3.87096774 C7.09258065,3.87096774 7.74193548,4.52129032 7.74193548,5.32258065",
    id: "Fill-5",
    fill: "#CAB5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5483871,5.32258065 C13.5483871,6.12387097 12.8990323,6.77419355 12.0967742,6.77419355 C11.2945161,6.77419355 10.6451613,6.12387097 10.6451613,5.32258065 C10.6451613,4.52129032 11.2945161,3.87096774 12.0967742,3.87096774 C12.8990323,3.87096774 13.5483871,4.52129032 13.5483871,5.32258065",
    id: "Fill-7",
    fill: "#CAB5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3548387,5.32258065 C19.3548387,6.12387097 18.7054839,6.77419355 17.9032258,6.77419355 C17.1009677,6.77419355 16.4516129,6.12387097 16.4516129,5.32258065 C16.4516129,4.52129032 17.1009677,3.87096774 17.9032258,3.87096774 C18.7054839,3.87096774 19.3548387,4.52129032 19.3548387,5.32258065",
    id: "Fill-9",
    fill: "#CAB5A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6129032,21.2903226 L48.3870968,21.2903226",
    id: "Stroke-11",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6129032,28.0645161 L28.0645161,28.0645161",
    id: "Stroke-13",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9032258,28.0645161 L35.3990323,36.4151613 L53.3370968,58.5958065 C54.6464516,60.2322581 57.0435484,60.4741935 58.653871,59.1329032 C60.2409677,57.81 60.4558065,55.4506452 59.1329032,53.8635484 L41.2054839,32.5441935 L32.9032258,28.0645161 Z",
    id: "Stroke-15",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2903226,55.1612903 L53.2258065,53.2258065",
    id: "Stroke-17",
    stroke: "#CAB5A0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply3);
export default __webpack_public_path__ + "static/media/icon-apply3.784cb484a76603988a64ae273ec6916a.svg";
export { ForwardRef as ReactComponent };